import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  background-color: black;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.8rem;
  text-align: center;
  padding: 2rem;
`;

const DelayedUnfreezeWrapper = ({ children, minutes = 5 }) => {
  const totalSeconds = minutes * 60; // 5 minutes
  const [remainingSeconds, setRemainingSeconds] = useState(totalSeconds);

  useEffect(() => {
    if (remainingSeconds <= 0) return;

    const interval = setInterval(() => {
      setRemainingSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingSeconds]);

  if (remainingSeconds <= 0) {
    return <>{children}</>;
  }

  const timeInMinutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <Wrapper>
      <p>
        The system will unfreeze in{" "}
        <strong>
          {timeInMinutes}:{seconds.toString().padStart(2, "0")}
        </strong>
      </p>
    </Wrapper>
  );

  return (
    <Wrapper>
      <p style={{ width: "62vw" }}>
        Sorry for the inconvenience. Payment has been delayed by more than 3
        months. Further delay will cause termination of the service.
      </p>
      <p>
        The system will unfreeze in{" "}
        <strong>
          {timeInMinutes}:{seconds.toString().padStart(2, "0")}
        </strong>
      </p>
    </Wrapper>
  );
};

export default DelayedUnfreezeWrapper;
